module.exports = __webpack_public_path__ + "media/images/4-966c1354.png";